<script>
import {dataLayerEvent} from "@utils/data-layer";
import UiButton from "@components/ui/ui-button/ui-button.vue";

export default {
    name: "MainScreen",
    components: {UiButton},
    methods: {
        openDigitalB2BEvent() {
            dataLayerEvent({
                eventId: 6,
                event: 'vntGeo',
                eventCategory: 'glavnaya',
                eventLabel: 'poprobovat',
                eventAction: 'button_click'
            });
        }
    }
}
</script>

<template>
    <div class="main-screen animate-item">
        <div class="main-screen-content main-screen-content-home-page main-screen-full-map">
            <div class="text-block-wrap">
                <div class="text-block">
                    <h1>Геоэффект</h1>
                    <p>Геоэффект — сервис для геоаналитики и геомаркетинга для бизнеса.<br>
                        Воспользуйтесь нашим продуктом по оценке и анализу локаций онлайн. Изучайте аудиторию и делайте выбор на основе геоданных о населении и турпотоке!</p>
                </div>
                <div class="text-footer-block main-screen-button">
                    <div
                        class="ui-button primary granat filled medium d-inline-block"
                        data-product="GeoEffect"
                        data-vitrine="Геоэффект"
                        data-btn-view="hidden"
                        data-bo-hw-lead-button="true"
                        data-bo-required-inn="true"
                        data-bo-not-required="email"
                        data-bo-subline=""
                        data-btn-text="Попробовать"
                        @click="openDigitalB2BEvent"
                    >
                        <p>
                            Попробовать
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '@design/sections/main-screen.scss';
    @import '@components/ui/ui-button/design/style.scss';
</style>